import { render } from "./OrderButton.vue?vue&type=template&id=1d4d41cf&scoped=true"
import script from "./OrderButton.vue?vue&type=script&lang=js"
export * from "./OrderButton.vue?vue&type=script&lang=js"

import "./OrderButton.vue?vue&type=style&index=0&id=1d4d41cf&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4d41cf"]])

export default __exports__